import { j as t } from "../../jsx-runtime-p91LotPX.mjs";
import { S as s, T as e } from "../../style-pk1ekFUy.mjs";
const {
  CheckableTag: n
} = e;
function T(a) {
  return /* @__PURE__ */ t.jsx(s, { ...a });
}
function g(a) {
  return /* @__PURE__ */ t.jsx(n, { ...a });
}
export {
  g as CheckableTags,
  T as Tags
};
//# sourceMappingURL=AntTag.js.map
